module.exports = __webpack_public_path__ + "a450892de73f3c71b582a4a8c0b24805.svg";